import { Sharetribe } from './sharetribe'
import {
  MAPPED_TRANSITION_NAMES_TO_TRANSACTION_STATES,
  USER_VISIBLE_TRANSACTION_STATES_PROVIDER,
  USER_VISIBLE_TRANSACTION_STATES_CUSTOMER,
} from '@loavies/c2c-models'

export class Provider {
  /**
   * @param {string} clientId
   * @param {string|null} [clientSecret]
   */
  constructor(
    clientId,
    clientSecret,
  ) {
    this.clientId = clientId
    this.clientSecret = clientSecret
  }

  /**
   * @param {Object} sdk
   * @param {Object} token
   */
  getNewInstance(sdk, token) {
    const provider = new Sharetribe(this.clientId, this.clientSecret, sdk)

    return provider.createInstance(token)
  }

  /**
   * Used for doing privileged transitions.
   * Only needed in Transaction process.
   * Swaps token for privileged token
   * @param {Object} sdk
   * @param {Object} trustedToken
   */
  getTrustedProviderInstance(sdk, trustedToken) {
    if (!trustedToken) {
      console.error('trustedToken required for this transition')
    }

    const store = sdk.tokenStore.memoryStore()
    store.setToken(trustedToken)

    return sdk.createInstance({
      clientId: this.clientId,
      tokenStore: store,
    })
  }

  getProviderImageVariants(sdk) {
    return {
      'fields.image': ['variants.default', 'variants.200', 'variants.400', 'variants.600', 'variants.900', 'variants.1000'],
      'imageVariant.200': sdk.util.objectQueryString({
        w: 200,
        fit: 'scale',
      }),
      'imageVariant.400': sdk.util.objectQueryString({
        w: 400,
        fit: 'scale',
      }),
      'imageVariant.600': sdk.util.objectQueryString({
        w: 600,
        fit: 'scale',
      }),
      'imageVariant.900': sdk.util.objectQueryString({
        w: 900,
        fit: 'scale',
      }),
      'imageVariant.1000': sdk.util.objectQueryString({
        w: 1000,
        fit: 'scale',
      }),
    }
  }

  getTransactionQueryIncludes() {
    return [
      'listing',
      'listing.images',
      'customer',
      'customer.profileImage',
      'provider',
      'provider.profileImage',
      'reviews',
      'reviews.author',
      'reviews.author.profileImage',
      'reviews.subject',
      'reviews.subject.profileImage',
    ]
  }

  /**
   * Not all transactions with last transitions should be shown in the front-end for the provider.
   * @return {string[]} transactionNames
   */
  getEligibleLastTransitionNamesForProvider() {
    return Object.entries(MAPPED_TRANSITION_NAMES_TO_TRANSACTION_STATES)
      .reduce((acc, [key, value]) => {
        if (USER_VISIBLE_TRANSACTION_STATES_PROVIDER.includes(value)) {
          acc.push(key)
        }

        return acc
      }, [])
  }

  /**
   * Not all transactions with last transitions should be shown in the front-end for the customer.
   * @return {string[]} transactionNames
   */
  getEligibleLastTransitionNamesForCustomer() {
    return Object.entries(MAPPED_TRANSITION_NAMES_TO_TRANSACTION_STATES)
      .reduce((acc, [key, value]) => {
        if (USER_VISIBLE_TRANSACTION_STATES_CUSTOMER.includes(value)) {
          acc.push(key)
        }

        return acc
      }, [])
  }
}
